/* Whether the signed-in caller may edit a given agent (OPSS-278 Phase 4).
 *
 * `Agent.can_edit` is already the single source of truth — computed server
 * side, it accounts for admin/owner/enforcement-off in one field, so nothing
 * here re-derives a role or ownership check. This module only turns that
 * boolean into what the UI needs: a reason string to show on hover. */

import type { Agent } from "./types";

/** Shown next to a disabled control. Matches the backend's 403 detail
 *  (`permissions.py` `AGENT_FORBIDDEN_DETAIL`) so a disabled-hover reason and
 *  a 403 that slips through some other path read the same. */
export const AGENT_EDIT_DISABLED_REASON =
  "Only the agent's creator or an organization admin can change this agent.";

/** `undefined` when the caller may edit (render the control enabled);
 *  otherwise the reason to show on hover/focus. */
export function editDisabledReason(
  agent: Pick<Agent, "can_edit">,
): string | undefined {
  return agent.can_edit ? undefined : AGENT_EDIT_DISABLED_REASON;
}
